"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowCardActions = void 0;
var react_1 = __importDefault(require("react"));
var CardActions_1 = __importDefault(require("@mui/material/CardActions"));
var MobileStepper_1 = __importDefault(require("@mui/material/MobileStepper"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var Utility_1 = require("./Utility");
var base_1 = require("@mui/base");
var Divider_1 = __importDefault(require("@mui/material/Divider"));
var Box_1 = __importDefault(require("@mui/material/Box"));
/**
 * Component that renders the workflow card action elements used for all screen components.
 *
 * @param divider boolean value to display a divider above workflow card action buttons
 * @param canGoNext boolean or function that indicates whether the next button should be enabled
 * @param canGoPrevious boolean or function that indicates whether the previous button should be enabled
 * @param showPrevious boolean that indicates whether the previous button should be displayed
 * @param showNext boolean that indicates whether the next button should be displayed
 * @param previousLabel label to display for the previous button
 * @param nextLabel label to display for the next button
 * @param onPrevious function called when the previous button is clicked
 * @param onNext function that is called when the next button is clicked
 * @param currentStep current step in the registration workflow
 * @param totalSteps total number of steps in the registration workflow
 * @param fullWidthButton boolean that indicates whether a button should be full width
 *
 * @category Component
 */
var useUtilityClasses = function (ownerState) {
    var classes = ownerState.classes;
    var slots = {
        root: ['root'],
        nextButton: ['nextButton'],
        previousButton: ['previousButton'],
        stepper: ['stepper'],
    };
    return (0, base_1.unstable_composeClasses)(slots, Utility_1.getWorkflowCardActionsUtilityClass, classes);
};
var WorkflowCardActions = function (props) {
    var _a = props.divider, divider = _a === void 0 ? true : _a, canGoPrevious = props.canGoPrevious, showPrevious = props.showPrevious, previousLabel = props.previousLabel, onPrevious = props.onPrevious, canGoNext = props.canGoNext, showNext = props.showNext, nextLabel = props.nextLabel, onNext = props.onNext, currentStep = props.currentStep, _b = props.totalSteps, totalSteps = _b === void 0 ? 5 : _b, fullWidthButton = props.fullWidthButton, sx = props.sx, otherCardActionsProps = __rest(props, ["divider", "canGoPrevious", "showPrevious", "previousLabel", "onPrevious", "canGoNext", "showNext", "nextLabel", "onNext", "currentStep", "totalSteps", "fullWidthButton", "sx"]);
    var defaultClasses = useUtilityClasses(props);
    var showStepperDots = currentStep !== undefined && totalSteps !== undefined && !fullWidthButton;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        divider ? (react_1.default.createElement(Divider_1.default, { sx: {
                width: { md: 'calc(100% + 3rem)', sm: 'calc(100% + 2rem)', xs: 'calc(100% + 2rem)' },
                mx: { md: -3, sm: -2 },
            } })) : null,
        react_1.default.createElement(CardActions_1.default, __assign({ sx: __spreadArray([
                { flexDirection: 'column', justifyContent: 'flex-end', p: { xs: 2, md: 3 } }
            ], (Array.isArray(sx) ? sx : [sx]), true), className: defaultClasses.root, "data-testid": defaultClasses.root }, otherCardActionsProps),
            react_1.default.createElement(MobileStepper_1.default, { variant: 'dots', position: 'static', steps: totalSteps, activeStep: currentStep, backButton: showPrevious ? (react_1.default.createElement(Button_1.default, { variant: "outlined", color: "primary", disabled: canGoPrevious === false || (typeof canGoPrevious === 'function' && !canGoPrevious()), onClick: onPrevious, sx: __spreadArray([{ width: fullWidthButton ? '100%' : 100 }], (Array.isArray(sx) ? sx : [sx]), true), className: defaultClasses.previousButton, "data-testid": defaultClasses.previousButton }, previousLabel)) : (react_1.default.createElement(Box_1.default, { sx: { width: fullWidthButton ? 0 : 100 } })), nextButton: showNext ? (react_1.default.createElement(Button_1.default, { variant: "contained", color: "primary", disableElevation: true, disabled: canGoNext === false || (typeof canGoNext === 'function' && !canGoNext()), onClick: onNext, sx: __spreadArray([{ width: fullWidthButton ? '100%' : 100 }], (Array.isArray(sx) ? sx : [sx]), true), className: defaultClasses.nextButton, "data-testid": defaultClasses.nextButton }, nextLabel)) : (react_1.default.createElement(Box_1.default, { sx: { width: fullWidthButton ? 0 : 100 } })), sx: {
                    background: 'transparent',
                    width: '100%',
                    p: 0,
                    '& .MuiMobileStepper-dot': showStepperDots ? { my: 0, mx: 0.5 } : { display: 'none' },
                }, className: defaultClasses.stepper, "data-testid": defaultClasses.stepper }))));
};
exports.WorkflowCardActions = WorkflowCardActions;
